import { render, staticRenderFns } from "./SalesThermalSaudiReports3.vue?vue&type=template&id=b187e048&"
import script from "./SalesThermalSaudiReports3.vue?vue&type=script&lang=js&"
export * from "./SalesThermalSaudiReports3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports